import React, { Component } from "react";
import { Config } from "../constant";
import Axios from "axios";
import { observer } from "mobx-react";
import { CommonStore, UpdateCaptchaResponse } from '../Store'
import reloadIcon from '../assets/reload.svg'

export default observer(class CaptchaField extends Component {
    constructor(props) {
        super(props);
        this.reloadCaptcha = this.reloadCaptcha.bind(this)
    }

    state = {
        captchaId: null,
        needRefresh: new Date().getTime(),
        loading: false
    }

    async componentDidMount() {
        await this.reloadCaptcha()
    }

    async reloadCaptcha() {
        try {
            const { onIdChange } = this.props
            this.setState(state => ({ ...state, loading: true }))
            const endpoint = Config.captchaChallengeUrl
            const result = await Axios.get(endpoint)
            const id = result.data.id
            onIdChange(id)
            UpdateCaptchaResponse(null)
            this.setState(state => ({ ...state, loading: false, captchaId: id }))
        } catch (e) {

        }
    }




    render() {
        const { captchaId } = this.state
        const reloadButton = (<div style={{ padding: '1px', background: 'white', cursor: 'pointer' }} onClick={(e) => {
            e.preventDefault()
            this.reloadCaptcha()
        }}><img src={reloadIcon} /></div>)


        const captchaResponse = CommonStore.captchaAnswerResponse
        // const captchaResponse = 'captchanotfoundrrexpired'
        let message = captchaId ? 'Enter the 6 code above' : ''

        switch (captchaResponse) {
            case 'answerisinvalid':
                message = 'Incorrect captcha answer'
                break;
            case 'captchanotfoundorexpired':
                message = 'Invalid or expired captcha. Please reload and try again'
                break;
            default:
                break;
        }
        console.log(captchaResponse, message)
        const imageUrl = `${Config.captchaImageUrl}?id=${captchaId}`
        // const imageUrl = 'https://blog.udemy.com/wp-content/uploads/2014/05/bigstock-test-icon-63758263.jpg'
        return (<div style={{ width: 'auto', display: 'flex', flexDirection: 'column' }} >
            <div style={{ display: 'flex', flexDirection: 'row', padding: '4px 4px', paddingTop: '10px', justifyContent: 'center' }}>
                <img width='180' height='40' src={imageUrl} alt='Click reload icon to refresh' /><br />
                {reloadButton}
            </div>
            <span style={{ textAlign: 'center', fontSize: '12px' }}>{message}</span>
            {this.props.children}
        </div>)
    }
})